import InvoiceType from "$routes/patient/[:patientId]/_lib/invoices/invoice-type";
import { Box } from "@material-ui/core";
import InvoicePrintItems from "./InvoicePrintItems";
import InvoicePrintSummary from "./InvoicePrintSummary";

const InvoiceTable = ({ invoice }) => {
  const enabledLineItems = invoice.lineItems.filter(
    (lineItem) => !lineItem.disabled,
  );
  return (
    <Box mb={1} display="flex" flexDirection="column" width="100%">
      <InvoicePrintItems lineItems={enabledLineItems} />
      <InvoicePrintSummary invoice={invoice} />
    </Box>
  );
};

InvoiceTable.propTypes = {
  invoice: InvoiceType.isRequired,
};

export default InvoiceTable;
